import { configureStore } from '@reduxjs/toolkit'
import dialogDefinitionReducer from "./slices/dialogDefinitionSlice"

export default configureStore({
  reducer: {
    dialogDefinitions: dialogDefinitionReducer
  },
})